import React, { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import DashNav from "../../Components/DashNav/DashNav";
import Gbtn from "../../Components/buttons/Gbtn";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import EmployeeSVG from "../../Components/SVGS/EmployeeSVG";
import InputField from "../../Components/InputField/InputField";
import Select from "react-select";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import "animate.css";
import noImage from "../../Assests/avatar1.png";
import { deleteClient, postClient, postRecentNewsNoti } from "../../api";
import validator from "validator";
import Dashboard from "../../Components/SVGS/DashboardSVG";
import { Enums } from "../../Enums";

function RecentNewsNotiAddEdit({ isEdit, }) {
    const icon = () => {
        return <Dashboard size="28" fill="#DF2F35" />;
    };

    const navigate = useNavigate();
    const location = useLocation();
    const RecentNewsNotiData =
        location.state && location.state ? location.state.NewsData : null;
    const page = location.state && location.state ? location.state.page : null;

    let baseUrl = process.env.REACT_APP_BASE_URL;
    const [isLoading, setIsLoading] = useState(false);
    const [contentErr, setcontentErr] = useState(false);
    const [err, setErr] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [recentNews, setRecentNews] = useState({
        id: RecentNewsNotiData ? RecentNewsNotiData.id : 0,
        content: RecentNewsNotiData ? RecentNewsNotiData.content : "",
        content_type: RecentNewsNotiData ? RecentNewsNotiData.content_type : "",
    });
    const options = [
        { value: Enums.recent_news_noti_type.news, label: 'News' },
        { value: Enums.recent_news_noti_type.notification, label: 'Notifications' },
    ]

    // fetching initial data
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setRecentNews({ ...recentNews, [name]: value });
    };

    const saveOnclick = () => {
        setErr(false);
        setIsLoading(true)
        postRecentNewsNoti(recentNews).then(({ data }) => {
            setIsLoading(false);
            if (data.error_code == 0 || data.error_code == 1) {
                navigate("/dashboard/recentNews", {
                    state: { page: page },
                });
            }
            else if (data.error_code == 2) {
                setErr(true)
                setErrMsg('Oops some server error occured.')
            }
            else {
                setErr(true)
                setErrMsg('Oops some server error occured. EC:' + data.error_code)

            }
        }).catch(err => {

            setIsLoading(false);
            setErr(true)
            setErrMsg('Network Error!.')
        })
    };

    return (
        <>
            <div className="mainDashView">
                <div>
                    <DashNav svg={icon} DashboardNavText={"Recent News & Notifications"} />
                </div>
                <div className="dashPanel" style={{ position: "relative" }}>
                    <h4
                        style={{
                            display: err ? "flex" : "none",
                            justifyContent: "center",
                            color: "red",
                        }}
                    >
                        <p>Network Error! Check your Network connnection.</p>
                    </h4>
                    <>
                        <div className="ar-dashpanel">
                            <h4
                                style={{
                                    display: err ? "flex" : "none",
                                    justifyContent: "center",
                                    color: "red",
                                    position: "absolute",
                                    top: "0",
                                    width: "90%",
                                }}
                            >
                                <p>Error! {errMsg}.</p>
                            </h4>
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                    }}
                                >
                                    <LoadingSpinner />
                                </div>
                            ) : (
                                <div>

                                    <div className="ae-formFields">
                                        <div className="ae-inputField">
                                            <InputField
                                                name={"content"}
                                                isErr={contentErr}
                                                errorMsg={
                                                    "content is required to show News"
                                                }
                                                value={recentNews.content}
                                                onChange={(e) => {
                                                    setcontentErr(false);
                                                    handleChange(e);
                                                }}
                                                placeholder={"Enter the content"}
                                                radius="5px"
                                            />
                                        </div>

                                        <div
                                            className="ae-inputField"
                                            style={{ position: "relative" }}
                                        >
                                            <div className="ar-selectText">Content Type</div>
                                            <Select
                                                options={options}
                                                placeholder={"Select Content Type"}
                                                value={options[recentNews?.content_type - 1]}
                                                className="ae-select"
                                                onChange={(data => {
                                                    setcontentErr(false);
                                                    handleChange({ target: { name: 'content_type', value: data.value } });
                                                })}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        //   backgroundColor: state.isFocused ? "white" : "#F5F6FA",
                                                        width: "310px",
                                                        border: `1px solid ${contentErr ? "red" : " lightgray"}`,
                                                        borderColor: contentErr ? "red" : "lightgray",
                                                        //   marginLeft: "4px",
                                                        marginRight: "0px",
                                                        borderRadius: "8px",
                                                        fontSize: "14px",
                                                        padding: "0px 13px",
                                                    }),
                                                }}
                                            />
                                            <div
                                                className="err-txt"
                                                style={{
                                                    display: contentErr ? "flex" : "none",
                                                    width: "150px",
                                                    position: "absolute",
                                                    bottom: "0",
                                                }}
                                            >
                                                Catageory is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="addEdit-btns">
                                <div className="ev-btnAdd ev-btn">
                                    <Gbtn
                                        text={isEdit ? "Update" : "Add"}
                                        func={saveOnclick}
                                        disabled={isLoading}
                                        color="#DF2F35"
                                        radius="5px"
                                        width="150px"
                                    />
                                </div>
                                <div className="ev-btnDel ev-btn">
                                    <Gbtn
                                        text={isEdit ? "Discard" : "Back"}
                                        color="#0061B1"
                                        func={() => {
                                            navigate("/dashboard/recentNews", {
                                                state: { page: page },
                                            });
                                        }}
                                        radius="5px"
                                        width="150px"
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </>
    );
}

export default RecentNewsNotiAddEdit;
